import { GraphQLClient } from "graphql-request";

export const graphqlClient = new GraphQLClient(
  import.meta.env.VITE_SWC_API_URL || "https://dev.cloud.pennylane.ai/graphql",
);
